import AttributeInput from './components/AttributeInput';
export default AttributeInput;
